import * as React from 'react';
const TABINDEX_ORIGINAL = 'data-tabindex-original';
const FOCUSABLE_ELEMENTS = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'details',
    'audio',
    'video',
    '[tabindex]',
];
export class ChildContainerTabIndexManager extends React.Component {
    constructor(props) {
        super(props);
        this.observingNode = React.createRef();
        this.getFocusableElementSelector = (parent = '') => FOCUSABLE_ELEMENTS.map((el) => `${parent} ${el}`).join(',');
        this.handleTabIndexes = () => {
            const { activeChildContainerSelector, childContainerSelector } = this.props;
            const observingNode = this.observingNode.current;
            const allFocusableElements = observingNode === null || observingNode === void 0 ? void 0 : observingNode.querySelectorAll(this.getFocusableElementSelector(childContainerSelector));
            const activeContainerElements = observingNode === null || observingNode === void 0 ? void 0 : observingNode.querySelectorAll(this.getFocusableElementSelector(activeChildContainerSelector));
            // set -1 tabindex for all interaction elements in all containers
            if (allFocusableElements) {
                allFocusableElements.forEach((item) => {
                    const itemTabindex = item.getAttribute('tabindex');
                    const originalItemTabindex = item.getAttribute(TABINDEX_ORIGINAL);
                    // set original if it doesn't exist or if it exists and tabindex was overwritten
                    if (originalItemTabindex == null || itemTabindex !== '-1') {
                        item.setAttribute(TABINDEX_ORIGINAL, itemTabindex !== null && itemTabindex !== void 0 ? itemTabindex : 'none');
                    }
                    item.setAttribute('tabindex', '-1');
                });
            }
            // reset tabIndex for children on active container
            if (activeContainerElements) {
                activeContainerElements.forEach((item) => {
                    const itemOriginalTabindex = item.getAttribute(TABINDEX_ORIGINAL);
                    if (itemOriginalTabindex === 'none' || itemOriginalTabindex == null) {
                        item.removeAttribute('tabindex');
                    }
                    else {
                        item.setAttribute('tabindex', itemOriginalTabindex);
                    }
                    item.removeAttribute(TABINDEX_ORIGINAL);
                });
            }
        };
        this.observeInteractiveContent = (mutationsList) => {
            const focusable = this.getFocusableElementSelector('');
            const hasFocusableMutation = mutationsList.some((entry) => 
            // a tabindex got updated (not by us)
            (entry.type === 'attributes' &&
                entry.attributeName === 'tabindex' &&
                entry.target instanceof Element &&
                entry.target.getAttribute(TABINDEX_ORIGINAL) != null &&
                entry.target.getAttribute('tabindex') !== '-1') ||
                // or a attribute was updated that does not belong to us
                (entry.type === 'attributes' &&
                    entry.attributeName !== 'tabindex' &&
                    entry.attributeName !== TABINDEX_ORIGINAL) ||
                // or a focusable child got mounted
                (entry.type === 'childList' &&
                    Array.from(entry.addedNodes).some((node) => node instanceof Element && node.matches(focusable))));
            if (hasFocusableMutation) {
                this.handleTabIndexes();
            }
        };
        if (typeof window !== 'undefined' && 'MutationObserver' in window) {
            this.contentObserver = new MutationObserver(this.observeInteractiveContent);
        }
    }
    componentDidMount() {
        this.handleTabIndexes();
        const observingNode = this.observingNode.current;
        if (observingNode && this.contentObserver) {
            this.contentObserver.observe(observingNode, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }
    }
    componentWillUnmount() {
        var _a;
        return (_a = this.contentObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.activeChildContainerSelector !==
            this.props.activeChildContainerSelector) {
            this.handleTabIndexes();
        }
    }
    render() {
        return React.createElement("div", { ref: this.observingNode }, this.props.children);
    }
}
